import React from 'react'
import {
  Layout,
  Header,
  Showcase,
  SectionTitle,
  Intro,
} from '../../../../components'

import data from './data.json'

export default props => {
  const toggleAccordion = accordionNumber => {
    document
      .getElementsByClassName('c-accordion__closed')
      [accordionNumber].classList.toggle('c-accordion__open')
    document
      .getElementsByClassName('c-accordion__header-icon')
      [accordionNumber].classList.toggle('icon--plus-sign')
    document
      .getElementsByClassName('c-accordion__header-icon')
      [accordionNumber].classList.toggle('icon--minus-sign')
    document
      .getElementsByClassName('c-accordion__header-title')
      [accordionNumber].classList.toggle('c-accordion__header-title--open')
  }

  const code = {
    default: `<div class="c-accordion">
    <button class="c-accordion__header-button" aria-expanded="false">
        <span class="c-accordion__header-title">Accordion Header</span>
        <div class="c-accordion__header-icon-container">
          <i class="icon icon--plus-sign c-accordion__header-icon"></i>
        </div>
    </button>
    <div class="c-accordion__closed" role="region">
        <div class="c-accordion__content">
          <p class="c-text-content">Lorem Ipsum</p>
        </div>
    </div>
  </div>`,
    group: `<div class="c-accordion-group">
  <div class="c-accordion">
    <button class="c-accordion__header-button" aria-expanded="false">
        <span class="c-accordion__header-title">Accordion Header</span>
        <div class="c-accordion__header-icon-container">
          <i class="icon icon--plus-sign c-accordion__header-icon"></i>
        </div>
    </button>
    <div class="c-accordion__closed" role="region">
        <div class="c-accordion__content">
          <p class="c-text-content">Lorem Ipsum</p>
        </div>
    </div>
  </div>
  <div class="c-accordion">
    <button class="c-accordion__header-button" aria-expanded="false">
        <span class="c-accordion__header-title">Accordion Header</span>
        <div class="c-accordion__header-icon-container">
          <i class="icon icon--plus-sign c-accordion__header-icon"></i>
        </div>
    </button>
    <div class="c-accordion__closed" role="region">
        <div class="c-accordion__content">
          <p class="c-text-content">Lorem Ipsum</p>
        </div>
    </div>
  </div>
</div>`,
  }

  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        exclusive={true}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>
            Accordions are a vertically stacked list of headers that toggle the
            display of related sections of content.
          </p>
          <p>
            Accordions can decrease cognitive load by grouping information and
            only presenting content that the user has selected. However, given
            their purpose, there is an inherent risk that users will miss
            information within the accordion. Do not use this component if it is
            crucial or required that a user review the content under all
            accordion headers.
          </p>
        </Intro>

        <SectionTitle>Usage</SectionTitle>

        {/* <Showcase site={data.site}
          title="Accordion"
          text="To use the accordion, you will need some js to add and remove the class c-accordion__open onto the div with the class c-accordion__closed as well as the class c-accordion__header-title--open onto the div with the class c-accordion__header-title. You will also need js to toggle icon--plus-sign and icon--minus-sign on the i tag in the accordion header"
          code={code.default}
        >
          <div class="c-accordion">
            <button
              class="c-accordion__header-button"
              aria-expanded="false"
              onClick={() => toggleAccordion(0)}
            >
              <span class="c-accordion__header-title">Accordion Header</span>
              <div class="c-accordion__header-icon-container">
                <i class="icon icon--plus-sign c-accordion__header-icon"></i>
              </div>
            </button>
            <div class="c-accordion__closed" role="region">
              <div class="c-accordion__content">
                <p class="c-text-content">Lorem Ipsum</p>
              </div>
            </div>
          </div>
        </Showcase> */}

        <Showcase
          site={data.site}
          title=""
          text="Accordions panels are individual button elements styled with the
          accordion class. Within the button element, there is a span for the
          header content and a div for the icon. Accordions require javascript to toggle the accordion__closed and
          accordion__open classes, as well as the icon--plus-sign and
          icon--minus-sign on click."
          code={code.group}
        >
          <div className="c-accordion-group">
            <div className="c-accordion">
              <button
                className="c-accordion__header-button"
                aria-expanded="false"
                onClick={() => toggleAccordion(0)}
              >
                <span className="c-accordion__header-title">
                  Accordion Header
                </span>
                <div className="c-accordion__header-icon-container">
                  <i className="icon icon--plus-sign c-accordion__header-icon"></i>
                </div>
              </button>
              <div className="c-accordion__closed" role="region">
                <div className="c-accordion__content">
                  <p className="c-text-content">Lorem Ipsum</p>
                </div>
              </div>
            </div>
            <div className="c-accordion">
              <button
                className="c-accordion__header-button"
                aria-expanded="false"
                onClick={() => toggleAccordion(1)}
              >
                <span className="c-accordion__header-title">
                  Accordion Header
                </span>
                <div className="c-accordion__header-icon-container">
                  <i className="icon icon--plus-sign c-accordion__header-icon"></i>
                </div>
              </button>
              <div className="c-accordion__closed" role="region">
                <div className="c-accordion__content">
                  <p className="c-text-content">Lorem Ipsum</p>
                </div>
              </div>
            </div>
            <div className="c-accordion">
              <button
                className="c-accordion__header-button"
                aria-expanded="false"
                onClick={() => toggleAccordion(2)}
              >
                <span className="c-accordion__header-title">
                  Accordion Header
                </span>
                <div className="c-accordion__header-icon-container">
                  <i className="icon icon--plus-sign c-accordion__header-icon"></i>
                </div>
              </button>
              <div className="c-accordion__closed" role="region">
                <div className="c-accordion__content">
                  <p className="c-text-content">Lorem Ipsum</p>
                </div>
              </div>
            </div>
          </div>
        </Showcase>
        <SectionTitle>Accessibility</SectionTitle>
        <p>
          Accordion containers must contain an{' '}
          <span className="inline__code">aria-expanded</span> attribute with a
          value of true or false to toggle the display of the header's content
          region.
        </p>

        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Accordions require at least a medium vertical margin
          <span className="inline__code">.l-margin-vertical--medium</span> and
          will fill 100% container width.
        </p>
      </Layout>
    </>
  )
}
